import { BoxIcon } from "lucide-react"
import { useCart } from "../../context/CartContext"
import RenderCartProp from "../RenderCartProp/RenderCartProp"
import './productssummary.scss'

const ProductsSummary = () => {
    const { cartData } = useCart()


    return (


        <div className="productsummary">

            {cartData.map((data, index) => (

                <div className="product-info" key={index}>

                    <div className='imageBox'>
                        {data.imgUrl && (<img src={data.imgUrl} className='image' alt='Product'></img>)}
                        {(!data.imgUrl || data.imgUrl === '') && (<BoxIcon size={40} strokeWidth={1} color='var(--gray-one)'></BoxIcon>)}
                    </div>

                    <div className='textcontent'>

                        <div className='productname'>{data.productName}</div>

                        <div className='props'>
                            <div className="propFlex">
                                 <div className='eachprop'>
                                    <span className='proptitle'>Qty:</span>
                                    <div className="rcartprop">
                                        <span className="eachSize">{data.quantity}</span>
                                    </div>
                                    
                                </div>
                                {data.selectedProperties?.map((data, index) => (
                                <div className='eachprop' key={index}>
                                    <span className='proptitle'>{data.name}:</span>
                                    <RenderCartProp type={data.type} value={data.value}></RenderCartProp>
                                </div>
                            ))}
                            </div>
                            
                            <div className='price'>{data.priceData.currency_symbol}{(data.totalAmount).toLocaleString()}</div>

                            

                            {/* <div className='eachprop'> <span className='proptitle'>Color:</span> <span className='propvalue'>Black</span> </div> */}
                        </div>

                    </div>

                </div>
            ))}



        </div>

    )
}


export default ProductsSummary

